import { createUseStyles } from 'react-jss'

const useAudienceSectionStyles = createUseStyles({
  sectionAgePickers: {
    display: 'flex',
    alignItems: 'flex-start',
    '& > div': {
      flex: 1
    },
    '& > div:nth-child(1)': {
      marginRight: 8
    }
  }
})

export default useAudienceSectionStyles
